export default "__VITE_ASSET__CgdbV3_i__"